import { useEffect, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import 'react-phone-input-2/lib/material.css';

function PhoneNumberControl(props) {
  const [lastLength, setLastLength] = useState(0);
  const [localError, setLocalError] = useState(false);

  const {
    disabled,
    events = {},
    error,
    label,
    name,
    onChange,
    placeholder,
    settings = {},
    value,
  } = props;

  const handleChange = function (phone) {
    setLastLength(phone.length);

    const { prefix = '+' } = settings;
    const target = {
      name,
      value: `${prefix}${phone}`,
    };
    onChange({
      target,
    });

    if (events?.onChange) {
      events.onChange(target);
    }
  };

  const handleBlur = () => {
    if (lastLength < 12) {
      setLocalError(true);
    } else {
      setLocalError(false);
    }
  };

  useEffect(() => {
    const el = document.querySelector('.special-label');
    if (el) {
      el.style.display = 'none';
    }
  }, [disabled]);

  return (
    <>
      <Box
        sx={{
          mb: 2,
        }}
      >
        <Typography
          style={{
            fontWeight: 'bold',
          }}
          variant="h6"
          gutterBottom
        >
          {label}
        </Typography>
        <PhoneInput
          country={settings?.defaultCountry || 'mx'}
          disabled={disabled}
          disableDropdown={true}
          countryCodeEditable={false}
          inputProps={{
            style: {
              cursor: disabled ? 'default' : undefined,
              width: '100%',
              borderRadius: '18px',
            },
            maxLength: 16,
          }}
          isValid={() => !!!error && !localError}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder={placeholder}
          prefix={settings?.prefix || '+'}
          specialLabel={label}
          value={value}
        />
      </Box>
      {(localError || props.helperText) && (
        <Box mt={-1.5}>
          <Typography
            color="error"
            children={
              localError
                ? 'El número de teléfono debe tener al menos 10 dígitos.'
                : props.helperText
            }
            variant="caption"
            style={{
              marginLeft: '14px',
            }}
          />
        </Box>
      )}
    </>
  );
}

PhoneNumberControl.defaultProps = {
  disabled: false,
  error: false,
  onChange: () => { },
  onBlur: () => { },
};

PhoneNumberControl.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.string,
  events: PropTypes.shape({
    onChange: PropTypes.func,
  }),
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  settings: {
    defaultCountry: PropTypes.string,
    disableDropdown: PropTypes.bool,
    onlyCountries: PropTypes.arrayOf(PropTypes.string),
    prefix: PropTypes.string,
  },
  value: PropTypes.string,
};

export default PhoneNumberControl;
